export type UserActivityType = {
  UserCreated: number;
  UserUpdated: number;
  UserLogin: number;
  UserLogout: number;
  UserActivated: number;
  UserForgotPassword: number;
  UserResetPassword: number;
  UserDeactivated: number;
};
